import { Fragment, type FunctionComponent, type PropsWithChildren, } from "react";
// import { TotalStaked, TotalUserStake, } from "@components";
import { TotalStaked, } from "@sections";
import "./SectionHeading.scss";

export declare type SectionHeadingProps = PropsWithChildren & {
	name?: string;
	blurb?: string;
};


export const SectionHeading: FunctionComponent<SectionHeadingProps> = ({
	name = "untitled",
	blurb,
	children,
}) => {

	const classes = () => ["section-heading", name,].join(" ");

	return (
		<section className={classes()}>
			<div className="left">
				<h3 className="title">{name}</h3>
				{ blurb && <div className="blurb"><p>{blurb}</p></div> }
				{ children }
			</div>
			<div className="right">
				<TotalStaked />
			</div>
		</section>
	);
}
